import { useTranslation } from 'react-i18next'
import Result from './Result'
import ResultColor from './ResultColor.enum'

interface AccessDeniedErrorProps {
  status?: 401 | 403
}

const AccessDeniedError = (props: AccessDeniedErrorProps) => {
  const { status = 401 } = props
  const { t } = useTranslation()

  return (
    <Result
      status={status}
      title={t(`error.${status}.title`)}
      description={t(`error.${status}.description`)}
      variant={ResultColor.Green}
    />
  )
}

export default AccessDeniedError
